import {uploadImageAdapter} from "@/plugins/UploadImageAdapter";
import {fileUrl} from "@/config/index";
/*
* 百度编辑器配置
* */
export const bdEditConfig = () => {
    return {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 320,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        // serverUrl: requestUrl + '/editor/controller.php',
        serverUrl: fileUrl + '/editor/controller.php',
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: '/UEditor/'
    }
}

/*
* CKEditor编辑器配置
* */
export const ckEditConfig = () => {
    return {
        placeholder: '请输入内容...',
        MENU_CONF: {
            uploadImage: {
                async customUpload(file, insertFn) {
                    // file 即选中的文件
                    // 自己实现上传，并得到图片 url alt href
                    // 最后插入图片
                    let _data = await uploadImageAdapter(file)
                    insertFn(`${_data.data.url}`, file.name, '')
                }
            },
            uploadVideo:{
                async customUpload(file, insertFn) {
                    let _data = await uploadImageAdapter(file)
                    insertFn(`${_data.data.url}`,'')
                }
            }
        }
    }
}
